export default {
  vote: 'Voter',
  see_results: 'Voir les résultats',
  close: 'Fermer',
  votes_one: '{{count}} vote',
  votes_other: '{{count}} votes',
};
